import React from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Tile = ({
  type,
  name,
  description,
  icon,
}) => (
  <Col xl="3" lg="4" md="6" className="mb-3">
    <Link
      to={`/translations/${type}`}
      className="btn bg-white p-5 border h-100 text-left d-flex flex-column shadow-hover"
    >
      <p>
        <FontAwesomeIcon fixedWidth icon={icon} size="2x" className="text-primary me-3" />
        <span className="h5 text-dark my-4 font-weight-bold">{name}</span>
      </p>
      <p className="text-body font-large mb-0">{description}</p>
    </Link>
  </Col>
);

export default Tile;
